<script setup lang="ts">
import { computed, defineEmits, defineProps } from "vue";
import Konva from "konva";
import Circle = Konva.Circle;
import { Point } from "@/types/stage";

const props = defineProps<{
  movePointsMode: boolean;
  points: Point[];
}>();

const emit = defineEmits<{
  (event: "point:move", index: number, e: Circle): void;
  (event: "point:remove", index: number, e: Circle): void;
}>();

const polygonConfig = computed(() => ({
  points: props.points.flatMap((p) => [p.x, p.y]),
  stroke: "#ff0000",
  strokeWidth: 2,
  closed: true,
}));
</script>

<template>
  <v-layer>
    <v-line :config="polygonConfig" />
    <!-- POLYGON'S POINTS -->
    <v-circle
      v-for="(p, i) in points"
      :key="i"
      :config="{
        x: p.x,
        y: p.y,
        radius: 6,
        fill: 'white',
        stroke: 'black',
        strokeWidth: 1,
        draggable: movePointsMode,
      }"
      @dragmove="(e: Circle) => emit('point:move', i, e)"
      @click="(e: Circle) => emit('point:remove', i, e)"
      @contextmenu="(e: Circle) => e.evt.preventDefault()"
    />
  </v-layer>
</template>
